import { BrowseGenreScreen } from "@components/Search/BrowseGenre";

export default BrowseGenreScreen;
